var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingCombLongLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 106,
    viewBox: "0 0 90 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 80,
    height: 106,
    rx: 4,
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 53.4443,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8453 65.333H62.2453V51.533C62.2453 48.133 62.2453 40.733 51.9953 40.733C48.1953 40.733 44.4453 41.883 41.7953 44.583L44.9453 47.733C46.5453 46.233 48.8453 45.233 51.3453 45.233C54.5453 45.233 56.8453 46.783 56.8453 49.733V50.383H55.3453C49.3453 50.383 40.2453 50.933 40.2453 58.733C40.2453 63.483 44.5453 65.933 48.9953 65.933C52.1953 65.933 54.9953 64.733 56.6953 62.033H56.8453V65.333ZM56.4953 55.933C56.4953 59.283 54.5453 61.433 50.4453 61.433C48.4953 61.433 46.2453 60.483 46.2453 58.283C46.2453 54.833 51.9453 54.583 55.2453 54.583H56.4953V55.933Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 9,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 17 9)",
    fill: "#52B3A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 26,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 17 26)",
    fill: "#52B3A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 43,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 17 43)",
    fill: "#52B3A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 60,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 17 60)",
    fill: "#52B3A7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 77,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 17 77)",
    fill: "#52B3A7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 94,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(90 17 94)",
    fill: "#52B3A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 97L2.99999 97C1.34314 97 -7.51197e-06 95.6569 -7.36713e-06 94L-1.98459e-07 12C-5.36119e-08 10.3431 1.34315 9 3 9L5.00001 9L5 97Z",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingCombLongLeft);
export default __webpack_public_path__ + "static/media/jobconfig-binding-comb-long-left.75cb7eb6b8b652f2c10e61fabf55f93f.svg";
export { ForwardRef as ReactComponent };